/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface CardReaderDTO
 */
export interface CardReaderDTOOptional {
  /**
   *
   * @type {string}
   * @memberof CardReaderDTO
   */
  readerId?: string;
  /**
   *
   * @type {string}
   * @memberof CardReaderDTO
   */
  label?: string;
  /**
   *
   * @type {string}
   * @memberof CardReaderDTO
   */
  status?: string;
}

export interface CardReaderDTO extends CardReaderDTOOptional {
  /**
   *
   * @type {string}
   * @memberof CardReaderDTO
   */
  readerId: string;
  /**
   *
   * @type {string}
   * @memberof CardReaderDTO
   */
  label?: string;
  /**
   *
   * @type {string}
   * @memberof CardReaderDTO
   */
  status?: string;
}

export interface CardReaderDTOTrackedI {
  /**
   *
   * @type {string}
   * @memberof CardReaderDTO
   */
  readerId?: string;
  readerIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CardReaderDTO
   */
  label?: string;
  labelIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CardReaderDTO
   */
  status?: string;
  statusIsSet: boolean;
}

transformDatesMap.set("CardReaderDTO", function (model: CardReaderDTO) {});

export type CardReaderDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  readerId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  label: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  status: PropertyMeta<MetaTypeBase<string>>;
}>;

export var CardReaderDTOMeta: CardReaderDTOMetaI = {} as CardReaderDTOMetaI;
CardReaderDTOMeta = typeMeta("CardReaderDTO", {
  readerId: propertyMeta("readerId", false, true, false, MetaTypesBase.string),
  label: propertyMeta("label", false, false, false, MetaTypesBase.string),
  status: propertyMeta("status", false, false, false, MetaTypesBase.string),
});

const metaI = CardReaderDTOMeta;

registerMeta(() => {});

export class CardReaderDTOTracked implements CardReaderDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  readerId__I?: string = undefined;
  readerIdIsSet: boolean = false;
  set readerId(v: undefined | string) {
    if (v !== undefined) {
      this.readerId__I = v;
      this.readerIdIsSet = true;
    } else {
      this.readerId__I = v || undefined;
      this.readerIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get readerId() {
    return this.readerId__I;
  }
  label__I?: string = undefined;
  labelIsSet: boolean = false;
  set label(v: undefined | string) {
    if (v !== undefined) {
      this.label__I = v;
      this.labelIsSet = true;
    } else {
      this.label__I = v || undefined;
      this.labelIsSet = false;
    }
    this.changeTracker = true;
  }
  get label() {
    return this.label__I;
  }
  status__I?: string = undefined;
  statusIsSet: boolean = false;
  set status(v: undefined | string) {
    if (v !== undefined) {
      this.status__I = v;
      this.statusIsSet = true;
    } else {
      this.status__I = v || undefined;
      this.statusIsSet = false;
    }
    this.changeTracker = true;
  }
  get status() {
    return this.status__I;
  }
  constructor(config?: CardReaderDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: CardReaderDTOOptional,
    options?: AssignOptions,
  ): CardReaderDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.readerId && this.readerIdApplyFilter(optionsRequired.filter)) {
      this.readerId = config.readerId;
      if (optionsRequired.unassign) this.readerIdIsSet = false;
      else this.readerIdIsSet = true;
    }
    if (config.label && this.labelApplyFilter(optionsRequired.filter)) {
      this.label = config.label;
      if (optionsRequired.unassign) this.labelIsSet = false;
      else this.labelIsSet = true;
    }
    if (config.status && this.statusApplyFilter(optionsRequired.filter)) {
      this.status = config.status;
      if (optionsRequired.unassign) this.statusIsSet = false;
      else this.statusIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CardReaderDTOTrackedI {
    const cloned = {} as CardReaderDTOTrackedI;
    if (
      this.readerIdIsSetDeep() &&
      this.readerIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.readerIdIsSet = true;
      cloned.readerId = this.readerId;
    } else {
      //cloned.readerIdIsSet = false
    }
    if (
      this.labelIsSetDeep() &&
      this.labelApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.labelIsSet = true;
      cloned.label = this.label;
    } else {
      //cloned.labelIsSet = false
    }
    if (
      this.statusIsSetDeep() &&
      this.statusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.statusIsSet = true;
      cloned.status = this.status;
    } else {
      //cloned.statusIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CardReaderDTOTrackedI {
    if (!this.readerIdApplyFilter(filter)) this.readerIdIsSet = false;

    if (!this.labelApplyFilter(filter)) this.labelIsSet = false;

    if (!this.statusApplyFilter(filter)) this.statusIsSet = false;

    return this;
  }
  readerIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CardReaderDTOMeta.readerId,
      CardReaderDTOMeta,
      this.readerId,
      this,
    );
  }
  readerIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.readerIdIsSet && this.readerIdApplyFilter(filter)) return true;

    return false;
  }
  labelApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(CardReaderDTOMeta.label, CardReaderDTOMeta, this.label, this);
  }
  labelIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.labelIsSet && this.labelApplyFilter(filter)) return true;

    return false;
  }
  statusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CardReaderDTOMeta.status,
      CardReaderDTOMeta,
      this.status,
      this,
    );
  }
  statusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.statusIsSet && this.statusApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.readerIdIsSetDeep(filter)) return true;
    if (this.labelIsSetDeep(filter)) return true;
    if (this.statusIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
